import { Service, inject } from '@angular/core'
import {
  SetEmployeeStatusBody,
  CreateEmployeeBody,
  GetEmployeesResponse,
  ManagedEmployee,
  DeleteEntityResponse,
  UpdateEmployeeBody,
} from '@seiri/shared/common'
import { ApiService } from '../api.service'

@Service()
export class ManageEmployeeApiService {
  private readonly api = inject(ApiService)

  getEmployees(entityId: string, init?: RequestInit) {
    return this.api.protectedFetchJson<GetEmployeesResponse>(`manage/entities/${entityId}/employees`, { ...init })
  }

  getEmployee(entityId: string, employeeId: string, init?: RequestInit) {
    return this.api.protectedFetchJson<ManagedEmployee>(`manage/entities/${entityId}/employees/${employeeId}`, {
      ...init,
    })
  }

  createEmployee(entityId: string, body: CreateEmployeeBody, init?: RequestInit) {
    return this.api.protectedFetchJson<ManagedEmployee>(`manage/entities/${entityId}/employees`, {
      method: 'POST',
      body: JSON.stringify(body),
      ...init,
    })
  }

  updateEmployee(entityId: string, employeeId: string, body: UpdateEmployeeBody, init?: RequestInit) {
    return this.api.protectedFetchJson<ManagedEmployee>(`manage/entities/${entityId}/employees/${employeeId}`, {
      method: 'PATCH',
      body: JSON.stringify(body),
      ...init,
    })
  }

  deleteEmployee(entityId: string, employeeId: string, init?: RequestInit) {
    return this.api.protectedFetchJson<DeleteEntityResponse>(`manage/entities/${entityId}/employees/${employeeId}`, {
      method: 'DELETE',
      ...init,
    })
  }

  setEmployeeStatus(entityId: string, employeeId: string, body: SetEmployeeStatusBody, init?: RequestInit) {
    return this.api.protectedFetchJson<ManagedEmployee>(`manage/entities/${entityId}/employees/${employeeId}/status`, {
      method: 'PUT',
      body: JSON.stringify(body),
      ...init,
    })
  }
}
